import { render, staticRenderFns } from "./ArrivalOrders.vue?vue&type=template&id=7073d0c0&scoped=true&"
import script from "./ArrivalOrders.vue?vue&type=script&lang=js&"
export * from "./ArrivalOrders.vue?vue&type=script&lang=js&"
import style0 from "./ArrivalOrders.vue?vue&type=style&index=0&id=7073d0c0&lang=less&scoped=true&"
import style1 from "./ArrivalOrders.vue?vue&type=style&index=1&id=7073d0c0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7073d0c0",
  null
  
)

export default component.exports